"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const react_1 = __importDefault(require("react"));
const Element_1 = require("../Element");
const IconButton_1 = require("../IconButton");
const Banner = ({ children, onDismiss }) => {
    return (react_1.default.createElement(Element_1.Element, { css: {
            position: 'relative',
            padding: [7, 8, 8],
            backgroundColor: '#252525',
            borderRadius: '4px',
        } },
        children,
        onDismiss ? (react_1.default.createElement(Element_1.Element, { css: { position: 'absolute', right: [1, 2, 4], top: [1, 2, 4] } },
            react_1.default.createElement(IconButton_1.IconButton, { name: "cross", variant: "square", title: "Dismiss", onClick: onDismiss }))) : null));
};
exports.Banner = Banner;
